import { api } from '../../lib/apiClient';
import { useAuthStore } from '../../store/authStore';

function ws() {
  const workspaceId = useAuthStore.getState().workspaceId;
  if (!workspaceId) throw new Error('No active workspace selected');
  return `/workspaces/${workspaceId}`;
}

export const commentKeys = {
  list: (targetType, targetId) => ['comments', targetType, targetId],
  thread: (id) => ['comment-thread', id],
  mentionable: (q) => ['mentionable', q ?? ''],
  myMentions: (unseen) => ['my-mentions', Boolean(unseen)],
};

export async function listComments(targetType, targetId, { unresolved } = {}) {
  const { data } = await api.get(`${ws()}/comments`, {
    params: { targetType, targetId, limit: 100, ...(unresolved ? { unresolved: true } : {}) },
  });
  return data;
}

export async function getThread(id) {
  const { data } = await api.get(`${ws()}/comments/${id}/thread`);
  return data;
}

export async function createComment(payload) {
  const { data } = await api.post(`${ws()}/comments`, payload);
  return data;
}

export async function updateComment({ id, body }) {
  const { data } = await api.patch(`${ws()}/comments/${id}`, { body });
  return data;
}

export const deleteComment = (id) => api.delete(`${ws()}/comments/${id}`);
export const resolveComment = (id) => api.post(`${ws()}/comments/${id}/resolve`);
export const reopenComment = (id) => api.post(`${ws()}/comments/${id}/reopen`);
export const pinComment = (id) => api.post(`${ws()}/comments/${id}/pin`);
export const unpinComment = (id) => api.post(`${ws()}/comments/${id}/unpin`);

export async function mentionableUsers(q) {
  const { data } = await api.get(`${ws()}/comments/mentionable`, { params: q ? { q } : {} });
  return data;
}

/** Per-target thread counts for a batch of ids → { [targetId]: { total, unresolved } }. */
export async function commentCounts(targetType, ids) {
  if (!ids.length) return {};
  const { data } = await api.get(`${ws()}/comments/counts`, {
    params: { targetType, ids: ids.join(',') },
  });
  return data;
}

// ---- mention inbox (cross-workspace) ----
export async function myMentions(unseen) {
  const { data } = await api.get('/me/mentions', { params: unseen ? { unseen: 'true' } : {} });
  return data;
}
export const markMentionsSeen = () => api.post('/me/mentions/seen');
export const markMentionSeen = (id) => api.post(`/me/mentions/${id}/seen`);
